import 'whatwg-fetch';
import { middle_dev, middle_key_val } from 'config';
import { couponsWeb_controller } from 'config';
import { kiosko_controller } from 'config';

const authHeader = new Headers();
authHeader.append('Accept', 'application/json');
authHeader.append('Content-Type', 'application/json');

export default class CartService{
    static createCartHeader(payload = {}) {
        /*
        *   @createcart
        *   Crea el carrito para la sesión del cliente
        *   
        *   OUT     |   data[payload]   |   object
        */
        authHeader.set('X-API-KEY', middle_key_val);
        authHeader.set('Authorization', `Bearer ${JSON.parse(localStorage.getItem('sessionData')).token}`);
        return fetch(`${middle_dev}/${couponsWeb_controller}/auth/crearCarrito`, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: authHeader, 
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(payload)
            }
        ).then((data) => {
            return data.json()
        })
    }
    static createCartBody(payload = {}) {
        /*
        *   @createcartdetail
        *   Crea el detalle del carrito, lista de id's de cupones agregados por el cliente
        *   
        *   IN      |   carrito (Id)    |   string
        *   IN      |   idcupon (Id)    |   string
        *   OUT     |   data[payload]   |   object
        */
        authHeader.set('X-API-KEY', middle_key_val);
        authHeader.set('Authorization', `Bearer ${JSON.parse(localStorage.getItem('sessionData')).token}`);
        return fetch(`${middle_dev}/${couponsWeb_controller}/auth/crearDetalleCarrito`, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: authHeader, 
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(payload)
            }
        ).then((data) => {
            return data.json()
        })
    }
    static deleteCartBody(payload = {}) {
        /*
        *   @deletecartdetail
        *   Elimina un cupón del carrito
        *   
        *   IN      |   carrito (Id)    |   string
        *   IN      |   idcupon (Id)    |   string
        *   OUT     |   data[payload]   |   object
        */
        authHeader.set('X-API-KEY', middle_key_val);
        authHeader.set('Authorization', `Bearer ${JSON.parse(localStorage.getItem('sessionData')).token}`);
        return fetch(`${middle_dev}/${couponsWeb_controller}/auth/borrarDetalleCarrito`, {
                method: 'DELETE',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: authHeader, 
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(payload)
            }
        ).then((data) => {
            return data.json()
        })
    }
    static getCartBody(cartId = '') {
        /*
        *   @getCartBody
        *   Devuelve lista de cupones agregados al carrito
        *   
        *   OUT     |   data[payload]   |   object
        */
        authHeader.set('X-API-KEY', middle_key_val);
        authHeader.set('Authorization', `Bearer ${JSON.parse(localStorage.getItem('sessionData')).token}`);
        return fetch(`${middle_dev}/${couponsWeb_controller}/auth/getCarritoDetalle?carrito=${cartId}`,{ headers: authHeader }).then((data) => {
            return data.json()
        })
    }
    static releaseCart(payload = {}) {
        /*
        *   @releasecart
        *   Libera el carrito para obtener el código de canje
        *   
        *   IN      |   carrito (Id)    |   string
        *   OUT     |   data[payload]   |   object
        */
        authHeader.set('X-API-KEY', middle_key_val);
        authHeader.set('Authorization', `Bearer ${JSON.parse(localStorage.getItem('sessionData')).token}`);
        return fetch(`${middle_dev}/${couponsWeb_controller}/auth/liberarCarrito`, {
                method: 'PUT',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: authHeader, 
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(payload)
            }
        ).then((data) => {
            return data.json()
        })
    }
    static getLastCart() {
        /*
        *   @getlastcart
        *   Obtiene el último carrito del cliente
        *   
        *   OUT     |   data[payload]   |   object
        */
        authHeader.set('X-API-KEY', middle_key_val);
        authHeader.set('Authorization', `Bearer ${JSON.parse(localStorage.getItem('sessionData')).token}`);
        return fetch(`${middle_dev}/${couponsWeb_controller}/auth/getLastCarrito`, { headers: authHeader }).then((data) => {
            return data.json()
        })
    }
    static getLastCartByCodLib(codLib) {
        /*
        *   @getlastcart
        *   Obtiene el último carrito del cliente
        *   
        *   OUT     |   data[payload]   |   object
        */
        authHeader.set('X-API-KEY', middle_key_val);
        return fetch(`${middle_dev}/${kiosko_controller}/getLastCarrito/${codLib}`, { headers: authHeader }).then((data) => {
            return data.json()
        })
    }
}